import axios from 'axios';
import { baseConfig } from './baseClient';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';

const storage = window.localStorage;

export const authClient = axios.create(baseConfig);

authClient.interceptors.request.use(
  (config) => {
    const token = storage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(new Error(error)),
);
